export default "__VITE_ASSET__Cj0cZNB0__"